module.exports = {
	"articleTitle1": "Pierpont Commons Cafe to be renovated by fall 2014",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Pierpont Commons",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/pierpont-hosts-renovation-kickoff-event",
	"articleSnippet1": "Dec 19, 2013 ... At the University's Board of Regents meeting Thursday, the board approved the \nrenovation of Pierpont Commons' Commons Cafe on North ...",
	"articleSnippet2": "Feb 26, 2014 ... Ian Dillingham/Daily: University Unions Director John Taylor speaks at the \nrenovation kick-off for new Fireside Cafe at Pierpont Commons ...",
	"totalMisc": 0,
	"articleTitle2": "Pierpont Commons Cafe to close for renovations",
	"address": "2101 Bonisteel Blvd. Ann Arbor, MI",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160212/smk.FEA_.CapsPlayDay.2.10.16280.jpg?itok=1NPc4Jdx",
			"author": "Sinduja Kilaru",
			"caption": "LSA senior Robin Griffin and Art & Design graduate students Clara McClenon and Jon Verney sign a poster during CAPS Play Day in Pierpont on Wednesday."
		}
	],
	"position": {
		"lat": 42.291203,
		"lng": -83.717267
	},
	"tips": [
		{
			"text": "Lots of food here, try different things and find your favorite go-to.",
			"person": "Bob Lesser"
		},
		{
			"text": "As the name suggests, there are some nice common areas here to study.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pierpont.json
// module id = 947
// module chunks = 0